export default __webpack_public_path__ + "static/media/tag-loader.adf1ad40.svg";